import { Eye } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { getViewAs, setViewAs } from '@/lib/view-as'

/** The strip that says whose Tapwork this is. Absent unless View As is on, and impossible to miss when it is. */
export function ViewAsBanner() {
  const viewing = getViewAs()
  if (!viewing) return null
  return (
    <div role="status" className="fixed bottom-4 left-1/2 z-toast flex max-w-[92vw] -translate-x-1/2 items-center gap-3 rounded-full bg-warning px-4 py-2 text-sm font-medium text-text-inverse shadow-lg">
      <Eye className="size-4 shrink-0" aria-hidden />
      <span className="truncate">Viewing as {viewing.displayName} · read-only</span>
      <Button type="button" size="sm" variant="secondary" className="h-7" onClick={() => { setViewAs(null); window.location.assign('/') }}>Exit</Button>
    </div>
  )
}
